<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-10">
                <!-- <div class="float-right">
                    <button class="btn dash-btns mr-3"  [routerLink]="['/pos/category/manage']">Manage Item Category</button>
   
                    <button class="btn dash-btns" [routerLink]="['/pos/category/new']">New Category</button>
                </div> -->
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div> -->
                                <div class="text-center">
                                    <a class="view-h gary-t"> View Items</a>
                                </div>
                                
                                 <div class="pt-3">
                                    <div>
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Category Name</div>
                                             
                                            <div class="col-7 view-text"> {{rows.CategoryName}}</div>
                                        </div>
                                      
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Tax Type </div>
                                             
                                            <div class="col-7 view-text"> {{rows.TaxType}}</div>
                                        </div>
                                       
                                      
                                        <!-- <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Updated Datetime </div>
                                             
                                            <div class="col-7 view-text"> {{ rows.UpdatedDateTime }}</div>
                                        </div> -->
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">HSN Code </div>

                                            <div class="col-7 view-text"> {{rows.HSNCode}}</div>
                                        </div>
                                      
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Date Time</div>
                                             
                                            <div class="col-7 view-text"> {{rows.DateTime | date:'d/M/yy, h:mm a'}}</div>
                                        </div>
                                       
                                        <div class="text-right py-2">
                                            <button class="btn dash-btns mr-3"  [routerLink]="['/pos/category/manage']">Back</button>
                                            <!-- <button class=" damke_siteBtn" id="payButtonsList" [routerLink]="['/Coupon/ManageCoupons']">View Coupons</button>                                  -->
                                                                              </div>                                                            
                                    </div>
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>
          
            </div>
        </div>
    </section>
</div>